import {FormState} from "mixins/FormTypes"
import {AxiosError, AxiosResponse} from "axios"

export type HttpActions = 'post' | 'get' | 'put' | 'delete' | 'patch'

export type Http = {
  post: <R>(uri: string, state: FormState) => Promise<any>
  put: <R>(uri: string, state: FormState) => Promise<any>
  patch: <R>(uri: string, state: FormState) => Promise<any>
  delete: <R>(uri: string, state: FormState) => Promise<any>
  sendForm: <R>(action: HttpActions, uri: string, state: any) => Promise<any>
}

export const Http = {
  /**
   * Helper method for making POST HTTP requests.
   */
  post: <R>(uri: string, state: FormState): Promise<R> => {
    return Http.sendForm('post', uri, state)
  },

  /**
   * Helper method for making PUT HTTP requests.
   */
  put: <R>(uri: string, state: FormState): Promise<R> => {
    return Http.sendForm('put', uri, state)
  },

  /**
   * Helper method for making PATCH HTTP requests.
   */
  patch: <R>(uri: string, state: FormState): Promise<R> => {
    return Http.sendForm('patch', uri, state)
  },

  /**
   * Helper method for making DELETE HTTP requests.
   */
  delete: <R>(uri: string, state: FormState): Promise<R> => {
    return Http.sendForm('delete', uri, state)
  },

  /**
   * Send the form to the back-end server.
   *
   * This function will clear old errors, update "busy" status, etc.
   */
  sendForm: <R>(method: HttpActions, uri: string, state: FormState): Promise<R> => {
    return new Promise((resolve, reject) => {
      state.form.startProcessing(state)
      // @ts-ignore
      window.axios[method](uri, state.form)
        .then((response: AxiosResponse) => {
          state.form.finishProcessing(state)
          resolve(response.data)
        })
        .catch((errors: AxiosError) => {
          if (errors.response && errors.response.data) {
            state.form.setErrors(state, errors.response.data.errors || [])
            reject(errors.response.data)
          }

          reject('Error in Http Request, no error data returned');
        })
    })
  }
}
